"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Utilities_1 = require("../../Utilities");
var Icon_1 = require("../../Icon");
var Persona_Props_1 = require("./Persona.Props");
var stylesImport = require("./Persona.scss");
var styles = stylesImport;
var PersonaPresence = (function (_super) {
    tslib_1.__extends(PersonaPresence, _super);
    function PersonaPresence(props) {
        return _super.call(this, props) || this;
    }
    PersonaPresence.prototype.render = function () {
        var presence = this.props.presence;
        if (presence === Persona_Props_1.PersonaPresence.none) {
            return null;
        }
        return (React.createElement("div", { className: Utilities_1.css('ms-Persona-presence', styles.presence) },
            React.createElement(Icon_1.Icon, { className: Utilities_1.css('ms-Persona-presenceIcon', styles.presenceIcon), iconName: this._determineIcon() })));
    };
    PersonaPresence.prototype._determineIcon = function () {
        var presence = this.props.presence;
        if (presence !== Persona_Props_1.PersonaPresence.none) {
            var userPresence = Persona_Props_1.PersonaPresence[presence];
            switch (userPresence) {
                case 'online':
                    userPresence = 'SkypeCheck';
                    break;
                case 'away':
                    userPresence = 'SkypeClock';
                    break;
                case 'dnd':
                    userPresence = 'SkypeMinus';
                    break;
                default:
                    userPresence = '';
            }
            return userPresence;
        }
    };
    tslib_1.__decorate([
        Utilities_1.autobind
    ], PersonaPresence.prototype, "_determineIcon", null);
    return PersonaPresence;
}(React.Component));
exports.PersonaPresence = PersonaPresence;
//# sourceMappingURL=PersonaPresence.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/Persona/PersonaPresence.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/Persona/PersonaPresence.js
// module chunks = 1